function r(...o) {
  const i = [];
  for (const n of o)
    if (!(!n && n !== 0)) {
      if (Array.isArray(n)) {
        const t = r(...n);
        t && i.push(t);
        continue;
      }
      if (typeof n == "string") {
        n.length > 0 && i.push(n);
        continue;
      }
      typeof n == "number" && i.push(String(n));
    }
  return i.join(" ");
}
export {
  r as c
};
//# sourceMappingURL=cn-DlLpp5ix.js.map
